import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
// import apiService from '../../services/apiService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { DateFormatter } from "../../utils/DateFormatter";
import { FilterMatchMode } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from "primereact/tooltip";

// import '../../styles/pages/dataSets.scss';
// import DatasetsCard from "../../components/DatasetsCard";
// import DatasetsModal from "../../components/DatasetsModal";
// import Add from "../../assets/icons/add"

export default function Workflows() {
    const location = useLocation();
    // const [dataSetList, setdataSetList] = useState([]);
    // const [publicDataList, setPublicDataList] = useState([]);
    // const [privateDataList, setPrivateDataList] = useState([]);
    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));
    const [workflowData, setWorkflowData] = useState([]);

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getDataUserToken}`,
    };

    function getSessionStorageOrDefault(key, defaultValue) {
        const stored =  sessionStorage.getItem(key);
        if (!stored) {
          return defaultValue;
        }
        return JSON.parse(stored);
    
      }

    const [userid] = useState(
        getSessionStorageOrDefault('userid', null)
    );

    const [name, setName] = useState(null);     // eslint-disable-line no-unused-vars
    const [workflowtId, setWorkflowId] = useState(null);

    useEffect(() => {
        if (location.state){
            setName(location.state.name);
            setWorkflowId(location.state.id);
        } else {
            setName('No Dataset Selected');
            setWorkflowId(null);
        }

        // console.log('location state', location.state);
        // console.log('name', name);
        // console.log('workflowtId', workflowtId);

    }, [location.state]);

    useEffect(() => {
        document.title = `Workflows | Palmona Pathogenomics`
    }, []);

    useEffect(() => {

        if (!workflowtId) {
            fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/workflowDsInfo?userId=${userid}`, {
                headers,
                }).then((res) => res.json())
                .then(data => {
                    // console.log('workflow data', data);
                    setWorkflowData(data);
                }
                ).catch((error) => {
                    console.log('Error in getting workflowdata', error);
                });
        } else {
            fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/workflowDsInfo?userId=${userid}&wfId=${workflowtId}`, {
                headers,
                }
            ).then((res) => res.json())
            .then(data => {
                // console.log('workflow data', data);
                setWorkflowData(data);
            }
            ).catch((error) => {
                console.log('Error in getting workflowdata', error);
            });
        }

        setLoading(false);
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps

    // const getDataDetail = async (data, dataList) => {
    //     await apiService.GetDataDetails(data.id).then((res) => {
    //         const i = dataList.findIndex(x => x.id == data.id)
    //         let replacingData = { ...dataList[i], ...res.data }q
    //         dataList[i] = replacingData
    //         setdataSetList(dataList);
    //     }).catch(() => {
    //         const i = dataList.findIndex(x => x.id == data.id)
    //         let replacingData = { ...dataList[i] }
    //         dataList[i] = replacingData
    //         setdataSetList(dataList);
    //     })
    // }

    // const getDataSet = async () => {
    //     await apiService.GetDatasets().then((response) => {
    //         let dataList = response?.data
    //         dataList?.length > 0 && dataList?.map((data) =>
    //             getDataDetail(data, dataList)
    //         )
    //     }).catch((err) => {
    //         setError(err.response.status)
    //     })
    // };

    // useEffect(() => {
    //     let publicList = []
    //     let privateList = []
    //     dataSetList?.length > 0 && dataSetList?.map((data) => {
    //         if (data?.is_public == true) {
    //             publicList.push(data)
    //         }
    //         else {
    //             privateList.push(data)
    //         }
    //     })
    //     setPublicDataList(publicList)
    //     setPrivateDataList(privateList)
    // }, [dataSetList]);

    // useEffect(() => {
    //     getDataSet();
    // }, []);

    const dateTemplate = (workflow) => {
        return DateFormatter(workflow.createdAt);
    }

    // const resultsTemplate = (workflow => {

    //     // return (
    //     //     <>
    //     //         <Tooltip target=".resultslink" />
    //     //         <Link to={`../visualizations/?workflow=${workflow.id}`}>
    //     //             <i className="pi pi-external-link ml-auto resultslink"
    //     //                 data-pr-tooltip="Visualize these results"
    //     //                 data-pr-position="left"
    //     //                 data-pr-at="left+5 top"
    //     //                 data-pr-my="right center-2">
    //     //             </i>
    //     //         </Link>
    //     //     </>
    //     // )


    //     if (workflow.status === 'Success') {
    //     return (
    //         <>
    //             <Tooltip target=".resultslink" />
    //             <Link to={`../visualizations/?workflow=${workflow.id}`}>
    //                 <i className="pi pi-external-link ml-auto resultslink"
    //                     data-pr-tooltip="Visualize these results"
    //                     data-pr-position="left"
    //                     data-pr-at="left+5 top"
    //                     data-pr-my="right center-2">
    //                 </i>
    //             </Link>
    //         </>
    //     )
    //     } else {
    //         return (
    //             <p>&nbsp;</p>
    //         )
    //     }
    // })

    const workflowNameTemplate = (workflow => {
        if (workflow.status === 'Success') {
            return (
                <>
                <Tooltip target=".resultslink" />
                <Link to={`../visualizations/?workflow=${workflow.id}`}>
                    {workflow.name}
                </Link>
            </>
            )
        } else {
            return (
                <div>
                    {workflow.name}
                </div>
            )
        }
    })


    const datasetNameTemplate = (dataset => {
        return (
            <>
                <Tooltip target=".resultslink" />
                <Link to={`/datasets/dataset_details?datasetid=${dataset.dataset_id}`}>
                    {dataset.dataset_name}
                </Link>
            </>
        )
    })

    // Filters

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        number_of_datasets: { value: null, matchMode: FilterMatchMode.EQUALS },
        dataset_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        number_of_samples: { value: null, matchMode: FilterMatchMode.EQUALS },
        definition_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
        verified: { value: null, matchMode: FilterMatchMode.EQUALS },
        createdAt: { value: null, matchMode: FilterMatchMode.EQUALS }
    });
    const [loading, setLoading] = useState(true);

    const [globalFilterValue, setGlobalFilterValue] = useState('');


    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </span>
            </div>
        );
    };


    const header = renderHeader();

    // end of filters

    return (
        <div className="datasets-main">
            <div className="d-flex justify-content-between">
                <DataTable 
                    value={workflowData} 
                    responsiveLayout="scroll" 
                    stripedRows 
                    paginator 
                    rows={25} 
                    rowsPerPageOptions={[25, 50, 75, 100]} 
                    removableSort
                    emptyMessage="No workflows found."
                    filters={filters} 
                    filterDisplay="row" 
                    loading={loading}
                    globalFilterFields={['name', 'number_of_datasets', 'number_of_samples', 'definition_name', 'status', 'createdAt', 'dataset_name']}
                    header={header}
                    sortField="createdAt" 
                    sortOrder={-1}
                >
                    <Column field="name" header="Workflow" body={workflowNameTemplate} sortable filter filterPlaceholder="Search by name"></Column>
                    <Column field="dataset_name" header="Dataset Name" body={datasetNameTemplate}  sortable filter filterPlaceholder="Search by Dataset"></Column>
                    <Column field="number_of_samples" header="No. of Samples" sortable filter filterPlaceholder="Search by Count"></Column>
                    <Column field="definition_name" header="Definition Name" sortable filter filterPlaceholder="Search by Definition"></Column>
                    <Column field="status" header="Status" sortable filter filterPlaceholder="Search by status"></Column>
                    <Column field="createdAt" header="Date Created" body={dateTemplate} sortable filter filterPlaceholder="Search by date"></Column>
                </DataTable>
            </div>
            <br />
        </div>
    );
}